import React from "react";
import { FinancialDocument } from "@common/types/financialDocument";
import { Drawer } from "@design-system/Drawer/Drawer";
import { Separator } from "@design-system/Separator/Separator";
import { DocumentName } from "@components/documents/DocumentName";
import { ImporterPreviewNavigation } from "@components/importer/ImporterPreviewNavigation";
import importerStyles from "@components/importer/ImporterPage.module.scss";
import { useAccrualPreviewNavigation } from "../useAccrualPreviewNavigation";
import { AccrualImporterDocumentRow } from "../accrualImporter.types";

interface Props {
    financialDocument?: Pick<FinancialDocument, "id" | "fileName">;
    navigationRows: AccrualImporterDocumentRow[];
    onClose: () => void;
    guardNavigation?: (navigate: () => void) => void;
    children: React.ReactNode;
}

export const AccrualDraftDrawerShell: React.FC<Props> = ({
    financialDocument,
    navigationRows,
    onClose,
    guardNavigation = (navigate) => navigate(),
    children,
}) => {
    const { previewedIndex, totalCount, previewNext, previewPrevious } =
        useAccrualPreviewNavigation(navigationRows);

    return (
        <Drawer
            open
            direction="right"
            modal={false}
            size="fullScreen"
            dismissible={false}
            noPadding
            headerClassName={importerStyles.drawerHeader}
            headerAddonLeft={
                financialDocument ? (
                    <DocumentName
                        fileName={financialDocument.fileName}
                        icon
                        documentId={financialDocument.id}
                        textClassName={importerStyles.drawerDocumentName}
                    />
                ) : null
            }
            headerAddonBeforeClose={
                <div className={importerStyles.headerRight}>
                    <ImporterPreviewNavigation
                        onNext={() => guardNavigation(previewNext)}
                        onPrevious={() => guardNavigation(previewPrevious)}
                        currentIndex={previewedIndex + 1}
                        totalCount={totalCount}
                    />
                    <Separator
                        orientation="vertical"
                        className={importerStyles.headerSeparator}
                    />
                </div>
            }
            onClose={onClose}
        >
            <div className={importerStyles.drawerContent}>{children}</div>
        </Drawer>
    );
};
